export const avtars = [
  {
    id: 1,
    url: "https://cdn-icons-png.flaticon.com/128/4333/4333609.png",
  },
  {
    id: 2,
    url: "https://cdn-icons-png.flaticon.com/128/2202/2202112.png",
  },
  {
    id: 3,
    url: "https://cdn-icons-png.flaticon.com/128/2351/2351939.png",
  },
  {
    id: 4,
    url: "https://cdn-icons-png.flaticon.com/128/7789/7789917.png",
  },
  {
    id: 5,
    url: "https://cdn-icons-png.flaticon.com/128/190/190613.png",
  },
  {
    id: 6,
    url: "https://cdn-icons-png.flaticon.com/128/949/949635.png",
  },
  {
    id: 7,
    url: "https://cdn-icons-png.flaticon.com/128/2920/2920045.png",
  },
  {
    id: 8,
    url: "https://cdn-icons-png.flaticon.com/128/1993/1993341.png",
  },
  {
    id: 9,
    url: "https://cdn-icons-png.flaticon.com/128/1864/1864593.png",
  },
  {
    id: 10,
    url: "https://cdn-icons-png.flaticon.com/128/4086/4086679.png",
  },
];
